import { render, staticRenderFns } from "./eventreport.vue?vue&type=template&id=025b0ecf&"
import script from "./eventreport.vue?vue&type=script&lang=js&"
export * from "./eventreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports